<template>
  <div class="activity-indicator flex-center">
    <b-row no-gutters>
      <b-col align="center">
        <div id="loadingIcon"
             role="progressbar"
             aria-label="Processing Spinner">
        </div>
        <div class="text-heading text-28 text-600">
          {{ $t('processing') }}...
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
// Utilities
import Logger from '../../../utility/loggerUtil'

export default {
  name: 'activity-indicator',

  mounted () {
    try {
      document.body.insertBefore(this.$el, document.body.firstChild)
    } catch (e) {
      Logger.error('Failed to move activity indicator')
      Logger.debug(e)
    }
  }
}
</script>

<style lang="scss" scoped>
@use '../../../assets/styles/colors';

.activity-indicator {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 9999; /* Bootstrap modals use z-index of 1024 */
  width: 100%;
  height: 100%;
  text-align: center;
  background-color: colors.$white-50op;
}

#loadingIcon {
  width: 3.75rem;
  height: 3.75rem;
  border: 5px solid;
  border-left: 5px solid transparent !important;
  border-radius: 50%;
  -ms-animation: spin 1.5s linear infinite;
  -webkit-animation: spin 1.5s linear infinite;
  -moz-animation: spin 1.5s linear infinite;
  animation: spin 1.5s linear infinite;

  .c1l & {
    border-color: colors.$c1l--green-1;
  }

  .ccc & {
    border-color: colors.$ccc--blue-1;
  }

  .ccf & {
    border-color: colors.$ccf--navy-4;
  }

  .chs & {
    border-color: colors.$chs--green-1;
  }

  .cic & {
    border-color: colors.$cic--green-1;
  }

  .esm & {
    border-color: colors.$esm--green-3;
  }

  .inl & {
    border-color: colors.$black;
  }

  .tmx & {
    border-color: colors.$tmx--blue-1;
  }
}

@-ms-keyframes spin {
  from { -ms-transform: rotate(0deg); }
  to { -ms-transform: rotate(360deg); }
}

@-moz-keyframes spin {
  from { -moz-transform: rotate(0deg); }
  to { -moz-transform: rotate(360deg); }
}

@-webkit-keyframes spin {
  from { -webkit-transform: rotate(0deg); }
  to { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>

<i18n>
{
  "en": {
    "processing": "Processing"
  }
}
</i18n>
